import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Box, CircularProgress, Fab, Typography } from '@material-ui/core';
import QuestionDetails from './QuestionDetails';
import { getLiveTheme } from './liveTheme';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    card: {
        textAlign: 'center',
        background: 'rgba(28, 28, 34, 0.9)',
        color: 'white',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 16,
        border: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 12px 30px rgba(0,0,0,0.35)',
    },
    fab: {
        margin: theme.spacing(1.6),
        fontSize: 22,
        width: 56,
        height: 56,
        textAlign: 'center',
        color: '#f7f7fb',
        background: 'rgba(255, 255, 255, 0.08)',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        boxShadow: '0 8px 18px rgba(0,0,0,0.35)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 48,
            height: 48,
            fontSize: 19,
        },
    },
    fabRed: {
        backgroundColor: '#f56c64',
        "&:hover": { backgroundColor: '#b05145' },
        margin: theme.spacing(1.6),
        fontSize: 22,
        textAlign: 'center',
        color: '#1b1b1f',
        boxShadow: '0 8px 18px rgba(245,108,100,0.35)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 48,
            height: 48,
            fontSize: 19,
        },
    },
    fabRedBright: {
        backgroundColor: '#ff0000',
        "&:hover": { backgroundColor: '#d32121' },
        margin: theme.spacing(1.6),
        fontSize: 22,
        textAlign: 'center',
        color: '#1b1b1f',
        boxShadow: '0 8px 18px rgba(255,0,0,0.3)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 48,
            height: 48,
            fontSize: 19,
        },
    },
    fabYellow: {
        backgroundColor: '#f7f78d',
        "&:hover": { backgroundColor: '#abab61' },
        margin: theme.spacing(1.6),
        fontSize: 22,
        textAlign: 'center',
        color: '#1b1b1f',
        boxShadow: '0 8px 18px rgba(247,247,141,0.35)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 48,
            height: 48,
            fontSize: 19,
        },
    },
    fabYellowBright: {
        backgroundColor: '#fffb00',
        "&:hover": { backgroundColor: '#e9e512' },
        margin: theme.spacing(1.6),
        fontSize: 22,
        textAlign: 'center',
        color: '#1b1b1f',
        boxShadow: '0 8px 18px rgba(255,251,0,0.35)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 48,
            height: 48,
            fontSize: 19,
        },
    },
    fabGreen: {
        backgroundColor: '#55d685',
        "&:hover": { backgroundColor: '#3fa163' },
        margin: theme.spacing(1.6),
        fontSize: 22,
        textAlign: 'center',
        color: '#1b1b1f',
        boxShadow: '0 8px 18px rgba(85,214,133,0.35)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 48,
            height: 48,
            fontSize: 19,
        },
    },
    fabGreenBright: {
        backgroundColor: '#05ff00',
        "&:hover": { backgroundColor: '#19e315' },
        margin: theme.spacing(1.6),
        fontSize: 22,
        textAlign: 'center',
        color: '#1b1b1f',
        boxShadow: '0 8px 18px rgba(5,255,0,0.35)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 48,
            height: 48,
            fontSize: 19,
        },
    },
    fabSelected: {
        margin: theme.spacing(1.6),
        fontSize: 28,
        textAlign: 'center',
        width: 72,
        height: 72,
        color: '#f7f7fb',
        background: 'linear-gradient(135deg, rgba(236, 129, 255, 0.5), rgba(121, 134, 255, 0.5))',
        border: '2px solid rgba(255, 255, 255, 0.4)',
        boxShadow: '0 12px 24px rgba(0,0,0,0.45)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 52,
            height: 52,
            fontSize: 22,
        },
    },
    fabGreenSelected: {
        backgroundColor: '#55d685',
        "&:hover": { backgroundColor: '#3fa163' },
        margin: theme.spacing(1.6),
        fontSize: 28,
        textAlign: 'center',
        width: 72,
        height: 72,
        border: '2px solid rgba(255,255,255,0.55)',
        boxShadow: '0 12px 24px rgba(85,214,133,0.45)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 52,
            height: 52,
            fontSize: 22,
        },
    },
    fabGreenBrightSelected: {
        backgroundColor: '#05ff00',
        "&:hover": { backgroundColor: '#19e315' },
        margin: theme.spacing(1.6),
        fontSize: 28,
        textAlign: 'center',
        width: 72,
        height: 72,
        border: '2px solid rgba(255,255,255,0.55)',
        boxShadow: '0 12px 24px rgba(5,255,0,0.45)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 52,
            height: 52,
            fontSize: 22,
        },
    },
    fabRedSelected: {
        backgroundColor: '#f56c64',
        "&:hover": { backgroundColor: '#b05145' },
        margin: theme.spacing(1.6),
        fontSize: 28,
        textAlign: 'center',
        width: 72,
        height: 72,
        border: '2px solid rgba(255,255,255,0.55)',
        boxShadow: '0 12px 24px rgba(245,108,100,0.45)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 52,
            height: 52,
            fontSize: 22,
        },
    },
    fabRedBrightSelected: {
        backgroundColor: '#ff0000',
        "&:hover": { backgroundColor: '#d32121' },
        margin: theme.spacing(1.6),
        fontSize: 28,
        textAlign: 'center',
        width: 72,
        height: 72,
        border: '2px solid rgba(255,255,255,0.55)',
        boxShadow: '0 12px 24px rgba(255,0,0,0.45)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 52,
            height: 52,
            fontSize: 22,
        },
    },
    fabYellowSelected: {
        backgroundColor: '#f7f78d',
        "&:hover": { backgroundColor: '#abab61' },
        margin: theme.spacing(1.6),
        fontSize: 28,
        textAlign: 'center',
        width: 72,
        height: 72,
        border: '2px solid rgba(255,255,255,0.55)',
        boxShadow: '0 12px 24px rgba(247,247,141,0.45)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 52,
            height: 52,
            fontSize: 22,
        },
    },
    fabYellowBrightSelected: {
        backgroundColor: '#fffb00',
        "&:hover": { backgroundColor: '#e9e512' },
        margin: theme.spacing(1.6),
        fontSize: 28,
        textAlign: 'center',
        width: 72,
        height: 72,
        border: '2px solid rgba(255,255,255,0.55)',
        boxShadow: '0 12px 24px rgba(255,251,0,0.45)',
        '@media (max-width: 768px)': {
            margin: theme.spacing(0.75),
            width: 52,
            height: 52,
            fontSize: 22,
        },
    },
    fabGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: theme.spacing(0.5),
        marginTop: theme.spacing(0.5),
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        '@media (max-width: 768px)': {
            display: 'grid',
            gridTemplateColumns: 'repeat(9, minmax(0, 1fr))',
            gap: theme.spacing(0.5),
            padding: 0,
            alignItems: 'stretch',
            '& .MuiFab-root': {
                margin: 0,
                width: '100%',
                minWidth: 0,
                height: 'auto',
                aspectRatio: '1 / 1',
                fontSize: 'clamp(14px, 4vw, 22px)',
            },
        },
        '@media (max-width: 420px)': {
            gap: theme.spacing(0.25),
        },
    },
    primaryFabRow: {
        '@media (max-width: 768px)': {
            marginTop: theme.spacing(1.25),
        },
    },
    loadingState: {
        minHeight: 320,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(2),
        color: 'rgba(255, 255, 255, 0.8)',
        textAlign: 'center',
    },
    loadingSpinner: {
        color: '#c5b8ff',
    },
});

class Questions extends Component {

    hasMatchingQuestions = (props = this.props) => {
        const { question, contest, slider } = props;
        if (!question || !question.length) {
            return false;
        }
        const matchingQuestions = question.filter((item) => (
            Number(item.contest_id) === Number(contest)
            && Number(item.hour) === Number(slider)
        ));
        return matchingQuestions.length > 0;
    }

    state = {
        selectedQuestion: this.hasMatchingQuestions() ? 1 : null,
        speedRound: this.props.speedRound.speed_round,
        fabColor: this.props.user.fab_color,
        hasLoadedQuestions: this.hasMatchingQuestions(),
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown);
        if (this.hasMatchingQuestions()) {
            this.setState({ hasLoadedQuestions: true, selectedQuestion: 1 });
        } else {
            this.setState({ hasLoadedQuestions: false, selectedQuestion: null });
        }
        const contest = {
            contestId: this.props.contest,
            currentHour: this.props.slider
        };
        const queryString = Object.keys(contest).map(key => key + '=' + contest[key]).join('&');
        this.getCurrentHourQuestions(queryString);
        this.interval = setInterval(() => {
            let contest = {
                contestId: this.props.contest,
                currentHour: this.props.slider
            }
            let queryString = Object.keys(contest).map(key => key + '=' + contest[key]).join('&');
            this.getCurrentHourQuestions(queryString)
        }, 3000);
        this.getSpeedRoundInfo();
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
        clearInterval(this.interval);
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.user.fab_color !== prevProps.user.fab_color) {
            console.log('CHANGE FOUND!')
        }
        if (this.props.contest !== prevProps.contest) {
            const hasLoadedQuestions = this.hasMatchingQuestions(this.props);
            this.setState({
                selectedQuestion: hasLoadedQuestions ? 1 : null,
                hasLoadedQuestions,
            });
            let contest = {
                contestId: this.props.contest,
                currentHour: this.props.slider
            }
            let queryString = Object.keys(contest).map(key => key + '=' + contest[key]).join('&');
            this.getCurrentHourQuestions(queryString)
        }
        if (this.props.slider !== prevProps.slider) {
            const hasLoadedQuestions = this.hasMatchingQuestions(this.props);
            this.setState({
                selectedQuestion: hasLoadedQuestions ? 1 : null,
                hasLoadedQuestions,
            });
            let contest = {
                contestId: this.props.contest,
                currentHour: this.props.slider
            }
            let queryString = Object.keys(contest).map(key => key + '=' + contest[key]).join('&');
            this.getCurrentHourQuestions(queryString);
            this.getSpeedRoundInfo();
        }
        if (this.props.question !== prevProps.question) {
            const hasLoadedQuestions = this.hasMatchingQuestions();
            if (hasLoadedQuestions) {
                this.setState((prevState) => ({
                    hasLoadedQuestions,
                    selectedQuestion: prevState.selectedQuestion ?? 1,
                }));
            } else {
                this.setState((prevState) => ({
                    hasLoadedQuestions: true,
                    selectedQuestion: prevState.selectedQuestion ?? 1,
                }));
            }
        }
    }

    getCurrentHourQuestions(contest) {
        this.props.dispatch({
            type: 'FETCH_CURRENT_HOUR_QUESTIONS',
            payload: contest
        })
    }

    getSpeedRoundInfo() {
        this.props.dispatch({
            type: 'FETCH_SPEED_ROUND',
            payload: this.props.slider
        })
    }


    handleFabClick = (value) => {
        this.setState({
            selectedQuestion: value
        })
    }

    getMaxQuestionCount = () => {
        const numberOfQuestions = this.props.currentContest.number_of_questions;
        return this.props.speedRound.speed_round ? numberOfQuestions * 2 : numberOfQuestions;
    }

    handleKeyDown = (event) => {
        if (!event.altKey || event.ctrlKey || event.metaKey) {
            return;
        }
        if (/^Digit[1-9]$/.test(event.code)) {
            const value = Number(event.code.replace('Digit', ''));
            if (value <= this.getMaxQuestionCount()) {
                event.preventDefault();
                this.handleFabClick(value);
            }
        }
    }

    render() {

        const { classes } = this.props
        const liveTheme = getLiveTheme(this.props.user.color);
        const isLoading = !this.state.hasLoadedQuestions;
        const resolvedSelectedQuestion = isLoading ? null : (this.state.selectedQuestion ?? 1);

        if (isLoading) {
            return (
                <Box className={classes.loadingState}>
                    <CircularProgress className={classes.loadingSpinner} />
                    <Typography variant="h6">Loading questions…</Typography>
                    <Typography variant="body2">Syncing the latest updates for this hour.</Typography>
                </Box>
            );
        }

        let currentHourContestData = {
            contestId: this.props.currentContest.id,
            currentHour: this.props.slider
        }

        let numberOfQuestions = this.props.currentContest.number_of_questions

        let currentHour = this.props.slider

        let listOfQuestions = [];

        for (let i = 1; i <= numberOfQuestions; i++) {
            listOfQuestions.push(i);
        }

        if (this.props.speedRound.speed_round) {
            for (let i = numberOfQuestions + 1; i <= numberOfQuestions * 2; i++) {
                listOfQuestions.push(i);
            }
        }

        let fabClasses = []
        let button = {}

        if (this.props.question[0]) {
            for (let i = 0; i < listOfQuestions.length; i++) {
                // find the question that is number "i+1"
                let questionMatch = null;
                for (let each of this.props.question) {
                    if (each.question_number == i + 1) {
                        questionMatch = each;
                        break;
                    }
                }
                if (questionMatch) {
                    // found my question, set its color appropriately
                    if (this.props.user.fab_color === 'traditional' || this.props.user.fab_color == null || this.props.user.fab_color == '') {
                        if (questionMatch.correct == null || questionMatch.correct == 'NULL' || questionMatch.correct == '') {
                            fabClasses.push(button = { number: i + 1, color: classes.fabYellow, hardColor: 'yellow' })
                        } else if (questionMatch.correct == 'true') {
                            fabClasses.push(button = { number: i + 1, color: classes.fabGreen, hardColor: 'green' })
                        } else if (questionMatch.correct == 'false') {
                            fabClasses.push(button = { number: i + 1, color: classes.fabRed, hardColor: 'red' })
                        }
                    }      
                    if (this.props.user.fab_color === 'bright') {
                        if (questionMatch.correct == null || questionMatch.correct == 'NULL' || questionMatch.correct == '') {
                            fabClasses.push(button = { number: i + 1, color: classes.fabYellowBright, hardColor: 'yellow' })
                        } else if (questionMatch.correct == 'true') {
                            fabClasses.push(button = { number: i + 1, color: classes.fabGreenBright, hardColor: 'green' })
                        } else if (questionMatch.correct == 'false') {
                            fabClasses.push(button = { number: i + 1, color: classes.fabRedBright, hardColor: 'red' })
                        }
                    }            
                } else {
                    // no question in the DB for i+1, so use default color
                    fabClasses.push(button = { number: i + 1, color: classes.fab, hardColor: 'gray' })
                }
            }
        } else {
            for (let each of listOfQuestions) {
                fabClasses.push(button = { number: each, color: classes.fab, hardColor: 'gray' })
            }
        }

        let fabDisplay;
        fabDisplay = (fabClasses.map((fab) => {
            if (fab.number == resolvedSelectedQuestion) {
                if (this.props.user.fab_color === 'traditional' || this.props.user.fab_color == null || this.props.user.fab_color == '') {
                    if (fab.hardColor.includes('green')) {
                        return <Fab key={fab.number} value={fab.number} className={classes.fabGreenSelected} onClick={() => this.handleFabClick(fab.number)}>{fab.number}</Fab>
                    } else if (fab.hardColor.includes('red')) {
                        return <Fab key={fab.number} value={fab.number} className={classes.fabRedSelected} onClick={() => this.handleFabClick(fab.number)}>{fab.number}</Fab>
                    } else if (fab.hardColor.includes('yellow')) {
                        return <Fab key={fab.number} value={fab.number} className={classes.fabYellowSelected} onClick={() => this.handleFabClick(fab.number)}>{fab.number}</Fab>
                    } else {
                        return (
                            <Fab
                                key={fab.number}
                                value={fab.number}
                                className={classes.fabSelected}
                                style={{ background: liveTheme.fabSelectedBackground }}
                                onClick={() => this.handleFabClick(fab.number)}
                            >
                                {fab.number}
                            </Fab>
                        )
                    }
                }
                if (this.props.user.fab_color === 'bright') {
                    if (fab.hardColor.includes('green')) {
                        return <Fab key={fab.number} value={fab.number} className={classes.fabGreenBrightSelected} onClick={() => this.handleFabClick(fab.number)}>{fab.number}</Fab>
                    } else if (fab.hardColor.includes('red')) {
                        return <Fab key={fab.number} value={fab.number} className={classes.fabRedBrightSelected} onClick={() => this.handleFabClick(fab.number)}>{fab.number}</Fab>
                    } else if (fab.hardColor.includes('yellow')) {
                        return <Fab key={fab.number} value={fab.number} className={classes.fabYellowBrightSelected} onClick={() => this.handleFabClick(fab.number)}>{fab.number}</Fab>
                    } else {
                        return (
                            <Fab
                                key={fab.number}
                                value={fab.number}
                                className={classes.fabSelected}
                                style={{ background: liveTheme.fabSelectedBackground }}
                                onClick={() => this.handleFabClick(fab.number)}
                            >
                                {fab.number}
                            </Fab>
                        )
                    }
                }
            } else
                return <Fab key={fab.number} value={fab.number} className={fab.color} onClick={() => this.handleFabClick(fab.number)}>{fab.number}</Fab>

        }))

        return (
            <>
                <div className={`${classes.fabGrid} ${classes.primaryFabRow}`}>
                    {fabDisplay.slice(0, numberOfQuestions)}
                </div>
                <div className={classes.fabGrid}>
                    {fabDisplay.slice(numberOfQuestions, numberOfQuestions * 2)}
                </div>
                <QuestionDetails contest={currentHourContestData} selection={resolvedSelectedQuestion} />
            </>
        )

    }

}

const mapStateToProps = state => ({
    currentContest: state.currentContest,
    user: state.user,
    team: state.team,
    question: state.question,
    speedRound: state.speedRound
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(Questions)));
